import $ from 'jquery';

class DetectBrowser {
    constructor() {
        if(this.isIe()) {
            $('body').addClass('ua-msie');
        }
    }

    isIe() {
        var ua = window.navigator.userAgent;

        var msie = ua.indexOf('MSIE '); // <= ie10
        var trident = ua.indexOf('Trident/');// = ie11

        return (msie > 0 || trident > 0);
    }
}

export default DetectBrowser;



// WEBPACK FOOTER //
// ./components/views/detect-browser.js